import { render, staticRenderFns } from "./manage-language-modal.vue?vue&type=template&id=2ff6939a"
import script from "./manage-language-modal.vue?vue&type=script&lang=js"
export * from "./manage-language-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports